<template>
  <div>
    <b-row fluid class="mx-0 mb-2 mb-sm-3 justify-content-end">
      <b-button type="button" variant="primary" id="traRefresh" @click="getTraData()" class="mx-0">
        <Icon type="f" /> {{ $t('btn.f') }}
      </b-button>
    </b-row>
    <TransTable v-if="isUser" ref="traTab1" suffix="traTabNewU"
        :query="traTabDefU"
        showShow showSubmit showPagination
        :noHitText="$t('tra.tno')" />
    <TransTable v-if="!isUser" ref="traTab2" suffix="traTabNewC"
        :query="traTabDefC"
        showShow showPagination
        :noHitText="$t('tra.tno')" />
  </div>
</template>

<script>
import Icon from '@/components/Icon';
import TransTable from '@/components/transactions/TransTable';

export default {
  data() {
    return {
      traTabDefU: { q: 'state::PREPARED', p: '10' },
      traTabDefC: { q: 'state::PREPARED', p: '20' },
    }
  },
  computed: {
    isUser() {
      return this.$store.state.oLogin.isUser;
    },
  },
  methods: {
    getTraData() {
      if (this.isUser) {
        this.$refs['traTab1'].getTraData();
      } else {
        this.$refs['traTab2'].getTraData();
      }
    },
  },
  components: {
    TransTable,
    Icon,
  },
}
</script>
